import { Service } from '@mews-commander/data-access';
import { UnicodeEntity } from '@mews/enums';
import { LocalizedProperty, LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';

enum DataTestIds {
    NameWrapper = 'serviceName',
}

export const ServiceName: React.FC<{ service: Service }> = ({ service }) =>
    service.isActive ? (
        <LocalizedProperty property={service.names} data-test-id={DataTestIds.NameWrapper} data-test-active />
    ) : (
        <div>
            <LocalizedProperty property={service.names} data-test-id={DataTestIds.NameWrapper} data-test-inactive />
            {UnicodeEntity.NoBreakSpace}
            {UnicodeEntity.LeftParenthesis}
            <LocalizedText textKey={TextKey.Deleted} />
            {UnicodeEntity.RightParenthesis}
        </div>
    );
